import React from 'react';
import {
  Alert, AlertIcon, Box, Button, Text,
} from '@chakra-ui/react';
import { FiLock } from 'react-icons/fi';
import { useConfirm } from './ConfirmProvider';

// item 213 — shown on an edit form when ANOTHER user holds the edit lock. The form is
// read-only (Save is disabled) until the viewer takes over. Take Over steals the lock;
// the previous holder is bumped to read-only on their next heartbeat.
// item 1501 (Chad) — Take Over CONFIRMS first, naming the other editor and saying plainly
// that their unsaved changes are lost (it used to steal the lock on a single click).
const EditLockBanner: React.FC<{ holderName: string | null; onTakeOver: () => void }> = ({
  holderName, onTakeOver,
}) => {
  const confirm = useConfirm();
  const who = holderName || 'the other editor';
  const takeOver = async () => {
    if (!(await confirm(
      `Take over from ${who}? Their unsaved changes will be lost.`,
      { title: 'Take over editing', confirmLabel: 'Take Over', destructive: true },
    ))) return;
    onTakeOver();
  };
  return (
    <Alert status="warning" borderRadius="md" mb={4} fontSize="sm" alignItems="center">
      <AlertIcon as={FiLock} />
      <Box flex="1">
        <Text fontWeight="semibold">
          {holderName ? `${holderName} is editing this` : 'Someone else is editing this'}
        </Text>
        <Text>Your changes can&apos;t be saved until you take over.</Text>
      </Box>
      <Button size="sm" colorScheme="orange" ml={3} onClick={takeOver}>Take Over</Button>
    </Alert>
  );
};

export default EditLockBanner;
